/**
 * Client JS library
 */
var Bounty = require("./lib/class/bounty");
var ValueCaptured = require("./lib/class/capturer");
var Codebase = require("./lib/class/codebase");
var CodebaseModerator = require("./lib/class/codebase_moderator");
var Judge = require("./lib/class/commitee");
var Karma = require("./lib/class/karma");
var Token = require("./lib/class/token");
var Redeemer = require("./lib/class/redeemer");
var Vote = require("./lib/class/vote");

/**
 * ABIs
 */
var TokenABI = require("./lib/abi/KAT.json");
var BountyABI = require("./lib/abi/Bounty.json");
var BountyModeratorABI = require("./lib/abi/BountyModerator.json");
var CodebaseABI = require("./lib/abi/Codebase.json");
var CodebaseModeratorABI = require("./lib/abi/CodebaseModerator.json");
var JudgeABI = require("./lib/abi/Judge.json");
var KarmaABI = require("./lib/abi/KarmaDistribution.json");
var MultiSigWalletABI = require("./lib/abi/MultiSigWallet.json");
var SimpleDatabaseABI = require("./lib/abi/SimpleDatabase.json");
var ValueCapturedABI = require("./lib/abi/ValueCaptured.json");
var VoteModeratorABI = require("./lib/abi/VoteModerator.json");
var RedeemerABI = require("./lib/abi/Redeemer.json");

module.exports = {
  Bounty: Bounty,
  ValueCaptured: ValueCaptured,
  Codebase: Codebase,
  CodebaseModerator: CodebaseModerator,
  Judge: Judge,
  Karma: Karma,
  Token: Token,
  Redeemer: Redeemer,
  Vote: Vote,
  ABI: {
    Token: TokenABI,
    Bounty: BountyABI,
    BountyModerator: BountyModeratorABI,
    Codebase: CodebaseABI,
    CodebaseModerator: CodebaseModeratorABI,
    Judge: JudgeABI,
    Karma: KarmaABI,
    MultiSigWallet: MultiSigWalletABI,
    SimpleDatabase: SimpleDatabaseABI,
    ValueCaptured: ValueCapturedABI,
    VoteModerator: VoteModeratorABI,
    Redeemer: RedeemerABI
  }
};
